import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import PDVSComPotencial from "./components/PDVSComPotencial";
import PCandSkin from "./components/PCandSkin";
import RankingDistribuicao from "./components/RankingDistribuicao";
import RankingSegmento from "./components/RankingSegmento";
import RankingCidade from "./components/RankingCidade";
import RankingUF from "./components/RankingUF";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

const OBJECT_IDS = {
  RANKING: "tjQzgaU",
};

function PCandSkinDesktop({ app }) {
  const { selections } = useSelections();
  const [nameUser, setNameUser] = useState("");
  const { isLoading } = useOverviewData(app);
  const [selectedValue, setSelectedValue] = React.useState("Execucao");

  const getNameUser = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setNameUser(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getNameUser(OBJECT_IDS.USER_NAME);
    }
  }, [app, getNameUser, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <Grid container spacing={2}>
                {/* First row - 2 columns */}
                <Grid item xs={12} md={7}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={5}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>

                {/* Second row - 4 equal columns */}
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={7} className="container-tables-tops">
                    <PDVSComPotencial app={app} />
                  </Grid>
                  <Grid item xs={12} md={5} className="container-tables-tops">
                    <PCandSkin app={app} />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    md={6}
                    xl={3}
                    className="container-tables-tops"
                  >
                    <RankingDistribuicao app={app} />
                  </Grid>
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    md={6}
                    xl={3}
                    className="container-tables-tops"
                  >
                    <RankingSegmento app={app} />
                  </Grid>
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    md={6}
                    xl={3}
                    className="container-tables-tops"
                  >
                    <RankingUF app={app} />
                  </Grid>
                  <Grid
                    item
                    spacing={2}
                    xs={12}
                    md={6}
                    xl={3}
                    className="container-tables-tops"
                  >
                    <RankingCidade app={app} />
                  </Grid>
                </Grid>
                <Grid item spacing={2}>
                  <Footer app={app} />
                </Grid>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

PCandSkinDesktop.propTypes = {
  app: PropTypes.object,
};

export default PCandSkinDesktop;
